import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ToastrModule } from 'ngx-toastr';
import { ChatComponent } from './chat.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ChatInternalComponent } from './chat_internal.component';
import { Select2Module } from 'ng2-select2';
import { EmptyChatComponent } from './empty-chat/empty-chat.component';
import { ChatSideBar } from './side-bar/sidebar.component';
import { ComponentsModule } from '../../../../components/component.module';
import { ChatBoxComponent } from './chat-box/chat-box.component';
import { HelperModule } from '../../../../common/helper/helper.module';
import { ChatContentComponent } from './chat-box/chat-content/chat-content.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    BrowserModule,
    ToastrModule.forRoot(),
    ModalModule.forRoot(),
    TooltipModule.forRoot(),
    Select2Module,
    ComponentsModule,
    HelperModule,
  ],

  declarations: [
    ChatComponent,
    ChatInternalComponent,
    EmptyChatComponent,
    ChatSideBar,
    ChatBoxComponent,
    ChatContentComponent,
  ],
  exports: [ChatComponent],

  providers: [],
})
export class ChatModule {}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/chat/chat.module.ts